import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getDashboardPerformanceData = async (clientId?: number, fromDate?: string, endDate?: string, includeTestDatavalue?: number) => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    let url = `/dashboard/performancemetrics?clientId=${clientId}&fromDate=${fromDate}&toDate=${endDate}`;

    // Only add includeTestData parameter if value is 1
    if (includeTestDatavalue === 1) {
        url += `&includeTestData=1`;
    }

    const response = await http.get(url);
    // Return the response
    return response;
}